export const typesSJReview = {
    GET_SJREVIEW_SUCCESS:'GET_SJREVIEW_SUCCESS',
    GET_SJREVIEW_ERROR:'GET_SJREVIEW_ERROR',
    GET_SJREVIEW_BEGIN:'GET_SJREVIEW_BEGIN',
    SJCREATE_ADDRESS: 'SJRESERVATIONS_PRIMARY_ADDRESS',

    SJRESERVATIONS_PRIMARY_ADDRESS:'SJRESERVATIONS_PRIMARY_ADDRESS',

    GET_SJPRICEANDTAX_SUCCESS:'GET_SJPRICEANDTAX_SUCCESS',
    GET_SJPRICEANDTAX_ERROR:'GET_SJPRICEANDTAX_ERROR',
    GET_SJPRICEANDTAX_BEGIN:'GET_SJPRICEANDTAX_BEGIN',
    RESET_SJPRICEANDTAX_INIT: 'RESET_SJPRICEANDTAX_INIT'
}
